<template>
  <v-container fluid>
    <v-row
      align="center"
      justify="center"
      class="ma-0"
    >
      <v-card
        width="100%"
        elevation="10"
      >
        <v-card-title class="title">
          Criar Novidade
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            dark
            class="mb-2"
            @click="previewNews"
          >
            Preview
          </v-btn>          
        </v-card-title>
        <v-card-text>
          <v-form v-model="isFormValid" ref="form">
            <v-container fluid>
              <v-row
                align="center"
              >
                <v-col
                  cols="12"
                  md="6"
                  lg="6"
                  xl="6"
                >
                  <v-text-field
                    label="Título"
                    v-model="form.title"
                    prepend-icon="mdi-comma"
                    hint="Título da novidade"
                    persistent-hint
                    :rules="[rules.required]"
                  />
                </v-col>
              </v-row>
              <v-row>
              </v-row>
              <v-row
                align="center"
              >
                <v-col
                  cols="12"
                  md="12"
                  lg="12"
                  xl="12"
                >
                  <ckeditor :editor="editor" v-model="form.content" :config="editorConfig" class="ckeditor"></ckeditor>                
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  md="12"
                  lg="12"
                  xl="12"                
                >
                  <v-checkbox
                    v-model="form.bl_show"
                    label="Mostrar novidade"
                    color="indigo"
                    hide-details
                  ></v-checkbox>                  
                </v-col>
              </v-row> 
              <v-row class="ma-0 my-2">
                <v-btn                
                  color="red"
                  outlined
                  @click="cancelar"
                >
                  Cancelar
                </v-btn>                
                <v-spacer/>
                <v-btn
                  v-if="isEditing"
                  color="accent"
                  outlined
                  @click="atualizar"
                >
                  Atualizar
                </v-btn>
                <v-btn
                  v-else
                  color="accent"
                  outlined
                  @click="adicionar"
                >
                  Criar
                </v-btn>                
              </v-row> 
                          
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-row>

  </v-container>
</template>

<script>
import {createNews, updateNews} from "@/api/api-news";
import CKEditor from '@ckeditor/ckeditor5-vue2';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import {NOTIFICATION_TYPES, NotificationOptions} from "../../helpers/notify"
import {cloneDeep} from "lodash/lang"

export default {
  name: "NewsManager",
  components: {
      ckeditor: CKEditor.component
  },  
  data() {
    return {
      isFormValid: false,
      option: 0,
      item: null,
      form: {
        id_mappa_update: null,
        title: null,
        content: null,
        bl_show: true
      },
      rules: {
        required: value => !!value || 'Obrigatório'
      },
      editor: ClassicEditor,
      editorConfig: {
        toolbar: {
            items: [
                'heading', '|', 'bold', 'italic', '|', 'link', '|',
                'bulletedList', 'numberedList',
                'insertTable', '|',
                'outdent', 'indent', '|',
                'blockQuote', '|',
                'undo', 'redo'
            ],
            language: 'pt'
        }        
      }      
    }
  },
  created() {
    this.option = this.$route.query.option
    this.item = this.$route.query.item

    if (this.option == 1) {
      if (this.item) {
        let dados = JSON.parse(window.atob(this.item))       
        this.form.id_mappa_update = dados.id_mappa_update
        this.form.title = dados.title
        this.form.content = dados.content
        this.form.bl_show = dados.bl_show  
      } else {
        this.$notify(new NotificationOptions({
          message: "Não conseguimos consultar a novidade selecionada.",
          type: NOTIFICATION_TYPES.ERROR,
        }))        
      }
    }
  },
  methods: {
    previewNews() {
      this.$appMng.setIdNews(0)
      this.$appMng.setTitleNews(this.form.title)
      this.$appMng.setContentNews(this.form.content)
      this.$appMng.setShowNews(true)
    },
    cancelar() {
      this.$router.push("/app/news", () => {})
    },
    atualizar() {
      if(this.isFormValid) {
        let pk = this.form.id_mappa_update
        let send_form = cloneDeep(this.form)
        delete send_form.id_mappa_update
        updateNews(this.$apiAuth.getAuthToken(), pk, send_form)
        .then(() => {
          this.$notify(new NotificationOptions({
            message: "Novidade atualizada com sucesso.",
            type: NOTIFICATION_TYPES.SUCCESS,
          }))
          this.$router.push("/app/news", () => {})
        })
        .catch(() => {
          this.$notify(new NotificationOptions({
            message: "Não conseguimos atualizar a novidade",
            type: NOTIFICATION_TYPES.ERROR,
          }))
        }) 
      } else {
        this.$notify(new NotificationOptions({
          message: "Preencha todos os campos",
          type: NOTIFICATION_TYPES.INFO,
        }))        
      }
    },
    adicionar() {
      if(this.isFormValid) {
        let send_form = cloneDeep(this.form)
        delete send_form.id_mappa_update
        createNews(this.$apiAuth.getAuthToken(), send_form)
        .then(() => {
          this.$notify(new NotificationOptions({
            message: "Novidade cadastrada com sucesso.",
            type: NOTIFICATION_TYPES.SUCCESS,
          }))
          this.$router.push("/app/news", () => {})
        })
        .catch(() => {
          this.$notify(new NotificationOptions({
            message: "Não conseguimos cadastrar a novidade",
            type: NOTIFICATION_TYPES.ERROR,
          }))
        }) 
      } else {
        this.$notify(new NotificationOptions({
          message: "Preencha todos os campos",
          type: NOTIFICATION_TYPES.INFO,
        }))        
      }
    }
  },
  computed: {
    isEditing() {
      if (this.option == 0) return false

      return true
    },
  }
}
</script>

<style>
  .ck-content {
    min-height: 200px !important;
  }
</style>